import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const ClassificationList = Loadable(lazy(() => import("features/classification/components/List")));
const ClassificationPage = Loadable(lazy(() => import("features/classification/components/Page")));

const routes = {
  path: "classification",
  children: [
    { path: "", element: <ClassificationList /> },
    { path: "add", element: <ClassificationPage /> },
    { path: "edit/:classificationId?", element: <ClassificationPage /> },
  ],
};

export default routes;
